import React from "react";
import css from "./HomeBanner.module.css";
import lightning from "../img/lightning-charge.svg";

const HomeBanner = () => {
  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <div
      className={css.banner}
    >
      <img
        src={lightning}
        width="16"
        height="16"
        alt="LAOS Token
        "
      />{" "}
      <a data-testid="banner-text"
        href="/foundation"
        target="_self">
        The LAOS Foundation is closing - Call for maintenance to the community
      </a>
    </div>
  );
};

export default HomeBanner;
